// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

// Preferred name for the base route constant — the ROUTEOWNERS_SENTRY generator
// tries this name first. Any other name also works (the generator falls back to
// the first path constant in the file), but `baseRoute` is the convention.
const baseRoute = '/evaluation-ai'

const BaseEvaluationAiAreaRoutes = {
  route: baseRoute,
  Overview: { route: '/overview' },
  PrimitiveDetail: { route: '/overview/:primitiveType/:name' },
  Logs: { route: '/logs' },
  Requirements: { route: '/requirements' },
  Heatmap: { route: '/heatmap' },
}

const transformed = transformRoutes(BaseEvaluationAiAreaRoutes)

export const EvaluationAiAreaRoutes = {
  ...transformed,
  Overview: { ...transformed.Overview, path: '/overview' },
  PrimitiveDetail: {
    ...transformed.PrimitiveDetail,
    path: '/overview/:primitiveType/:name',
  },
  Logs: { ...transformed.Logs, path: '/logs' },
  Requirements: { ...transformed.Requirements, path: '/requirements' },
  Heatmap: { ...transformed.Heatmap, path: '/heatmap' },
}
